module.exports = function(bootstrap) {
	bootstrap.directive('calendar', ["$filter", function ($filter) {
		return {
			scope: {
				calendar: '=',
 				dateMax: '@',
 				dateMin: '@',
 				stayLessThan: '=',
 				stayMoreThan: '=',
 				initEmpty: '=?',
				onDoubleClick: '&?'
			},
            template: '<article role="dialog" class="calendarWidget">' +
                                '<button aria-label="previousYear" type="button" data-ng-click="previousYear()" class="previousYear"><span></span><span></span></button>' +
                                '<button aria-label="previousMonth" type="button" data-ng-click="previousMonth()" class="previousMonth"><span></span></button>' +
                                '<h1>{{monthYear}}</h1>' +
                                '<button aria-label="nextMonth" type="button" data-ng-click="nextMonth()" class="nextMonth"><span></span></button>' +
                                '<button aria-label="nextYear" type="button" data-ng-click="nextYear()" class="nextYear"><span></span><span></span></button>' +
                            '<ol>' +
                                '<li>S</li><li>M</li><li>T</li><li>W</li><li>T</li><li>F</li><li>S</li>' +
                            '</ol>' +
                            '<ol data-ng-repeat="rowCount in [0,1,2,3,4,5]">' +
                                '<li data-ng-repeat="day in daysArray.slice(rowCount*7,rowCount*7+7) track by $index">' +
                                    '<button aria-label="dayButton" type="button" data-ng-if="day" data-ng-disabled="rangeCheck(day.full)" data-ng-class="{selected: selectedFull == day.full}" data-ng-click="setDate(day.date)" data-ng-dblclick="onDoubleClick()">' +
										'{{day.date}}' +
                                    '</button>' +
                                '</li>' +
                            '</ol>' +
                        '</article>',
			link: function(scope, element, attrs) {
				scope.$watch('stayLessThan', function(v) {
					if (Number(current) > Number(v)) {
						console.debug(1);
						scope.setDate(v);
						buildCalendar(current);
					}
				});
				scope.$watch('stayMoreThan', function(v) {
					if (Number(current) < Number(v)) {
						console.debug(2);
						scope.setDate(v);
						buildCalendar(current);
					}
				});
				var current = scope.calendar || new Date();
				current.setHours(12);
				current.setMinutes(0);
				current.setSeconds(0);
				current.setMilliseconds(0);
				var today = new Date();
				today.setHours(12);
				today.setMinutes(0);
				today.setSeconds(0);
				today.setMilliseconds(0);
				scope.rangeCheck = function(date) {
					if (scope.dateMax && Number(date) > Number(today) + (86400000 * scope.dateMax) ) {
						return true;
					}
					if (scope.dateMin && Number(date) < Number(today) - (86400000 * scope.dateMin) ) {
						return true;
					}
				}
				var buildCalendar = function(current) {
					var daysArray = [];
					var next = new Date(current - 86400000);
					while (current.getMonth() === next.getMonth()) {
						// daysArray.unshift({full: Number(next), date: next.getDate()});
						daysArray.unshift({full: next.toDateString(), date: next.getDate()});
						next = new Date(next - 86400000);
					}
					next = current;
					while (current.getMonth() === next.getMonth()) {
						// daysArray.push({full: Number(next), date: next.getDate()});
						daysArray.push({full: next.toDateString(), date: next.getDate()});
						next = new Date(Number(next) + 86400000);
					}
					var dayOffset = (new Date((new Date(current)).setDate(1))).getDay();
					daysArray = (new Array(dayOffset)).concat(daysArray).concat(new Array(42 - daysArray[daysArray.length-1].date - dayOffset));
					scope.daysArray = daysArray;
					scope.monthYear = (['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'])[current.getMonth()] + ' ' + current.getFullYear();
				}

				scope.$watch('calendar', function(v) {
					if (v && v.toDateString() !== scope.selectedFull) {
						scope.setDate(v);
						buildCalendar(current);
					}
				});

				scope.setDate = function(date) {
					if (typeof date === 'number') {
						current.setDate(date);
					}
					else {
						current = date;
					}
					scope.calendar = new Date(current); // new Date() necessary because angular sucks
					// scope.selectedFull = Number(current);
					scope.selectedFull = scope.calendar.toDateString();
				};

				scope.previousMonth = function() {
					current.setMonth(current.getMonth() - 1);
					buildCalendar(current);
				};
				scope.nextMonth = function() {
					current.setDate(1); // Fixes an issue where if current date was the 31st, next month would skip a month if it did not also have 31 days
					current.setMonth(current.getMonth() + 1);
					buildCalendar(current);
				};
				scope.previousYear = function() {
					current.setFullYear(current.getFullYear() - 1);
					buildCalendar(current);
				};
				scope.nextYear = function() {
					current.setFullYear(current.getFullYear() + 1);
					buildCalendar(current);
				};

				buildCalendar(current);

				if (!scope.initEmpty) {
					scope.setDate(current);
				}

				scope.onDoubleClick = scope.onDoubleClick || function(){};
			}
		};
	}]);
};
